import {
  FolderFilled,
  FileImageFilled,
  FileTextFilled,
  FileZipFilled,
  FileMarkdownFilled,
  FileWordFilled,
  FilePptFilled,
} from "@ant-design/icons";

export default function getFileIcon(file) {
  // 判断是否为文件夹（需要特殊处理）
  if (file.type === "folder" || file.webkitRelativePath) {
    return <FolderFilled />;
  }
  // 判断图片类型（支持所有 image/* MIME 类型）
  if (file.type.startsWith("image/")) {
    return <FileImageFilled />;
  }
  // 备用方案：通过文件扩展名判断（适用于某些浏览器不返回 MIME 类型的情况）
  const ext = file.name.split(".").pop()?.toLowerCase();
  const imageExtensions = ["png", "jpg", "jpeg", "gif", "webp", "bmp"];
  const pressExtensions = ["zip", "rar"];
  const mdExtensions = ["md"];
  const wordExtensions = ["doc", "docx", "docm", "dot", "dotx", "dotm"];
  const pptExtensions = [
    "ppt",
    "pptx",
    "pptm",
    "pot",
    "potx",
    "potm",
    "pps",
    "ppsx",
    "ppsm",
  ];
  if (imageExtensions.includes(ext || "")) {
    return <FileTextFilled />;
  }
  if (pressExtensions.includes(ext || "")) {
    return <FileZipFilled />;
  }
  if (mdExtensions.includes(ext || "")) {
    return <FileMarkdownFilled />;
  }
  if (wordExtensions.includes(ext || "")) {
    return <FileWordFilled />;
  }
  if (pptExtensions.includes(ext || "")) {
    return <FilePptFilled />;
  }
  // 默认文件图标
  return <FileTextFilled />;
}
